import { api } from './client';

export interface SisSettlement {
  id: number;
  settlementNo: string;
  partyId: number | null;
  isGroup: boolean;
  storeName: string;
  group: string;
  periodStart: string;
  periodEnd: string;
  unitsSold: number;
  grossSale: number;
  commissionPct: number;
  commissionAmt: number;
  netReceivable: number;
  salaryDeduction: number;
  tdsAmount: number;
  finalReceivable: number;
  received: number;
  balance: number;
  status: string;
  createdAt: string;
  createdBy: string | null;
}

export interface SisSettlementPreview {
  partyId: number;
  storeName: string;
  group: string;
  grossSale: number;
  unitsSold: number;
  commissionPct: number;
  commissionAmt: number;
  netReceivable: number;
  salaryDeduction: number;
  finalReceivable: number;
  txnCount: number;
  commissionSet: boolean;
}

export async function listSisSettlements(filter: { partyId?: number; status?: string } = {}): Promise<SisSettlement[]> {
  const r = await api.get<SisSettlement[]>('/sis-settlement', { params: filter });
  return r.data;
}

export async function previewSisSettlement(partyId: number, from: string, to: string): Promise<SisSettlementPreview> {
  const r = await api.get<SisSettlementPreview>('/sis-settlement/preview', { params: { partyId, from, to } });
  return r.data;
}

export async function generateSisSettlement(payload: {
  partyId: number;
  periodStart: string;
  periodEnd: string;
  tdsAmount?: number;
  salaryDeduction?: number;
}): Promise<SisSettlement> {
  const r = await api.post<SisSettlement>('/sis-settlement/generate', payload);
  return r.data;
}

export interface GroupPreviewStore {
  partyId: number;
  storeName: string;
  grossSale: number;
  commissionAmt: number;
  netReceivable: number;
  salaryDeduction: number;
  unitsSold: number;
  txnCount: number;
}

export interface GroupPreviewTotals {
  grossSale: number;
  commissionPct: number;
  commissionAmt: number;
  netReceivable: number;
  salaryDeduction: number;
  unitsSold: number;
  txnCount: number;
  storeCount: number;
  storesWithSales: number;
}

export interface GroupSettlementPreview {
  group: string;
  stores: GroupPreviewStore[];
  totals: GroupPreviewTotals;
  alreadySettled: boolean;
}

export async function previewGroupSisSettlement(group: string, from: string, to: string): Promise<GroupSettlementPreview> {
  const r = await api.get<GroupSettlementPreview>('/sis-settlement/preview-group', { params: { group, from, to } });
  return r.data;
}

export async function generateGroupSisSettlement(payload: {
  group: string;
  periodStart: string;
  periodEnd: string;
  tdsAmount?: number;
}): Promise<SisSettlement> {
  const r = await api.post<SisSettlement>('/sis-settlement/generate-group', payload);
  return r.data;
}

export async function receiveSisSettlementPayment(
  id: number,
  payload: { amount: number; mode?: string; ref?: string },
): Promise<SisSettlement> {
  const r = await api.post<SisSettlement>(`/sis-settlement/${id}/receive-payment`, payload);
  return r.data;
}

export async function closeSisSettlement(id: number, note?: string): Promise<SisSettlement> {
  const r = await api.post<SisSettlement>(`/sis-settlement/${id}/close`, { note });
  return r.data;
}
